import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../../components/AuthProvider";
import Container from "../../components/Container";
import Content from "../../components/Content";
import { IMPLEMENTATION_EMAIL } from "../../utils/constants";
import ErrorMessage from "../../components/Layout/ErrorMessage";
import styles from "../Login/Login.module.scss";

const CreateSession = () => {
  const [hasLoaded, setHasLoaded] = React.useState(false);
  const [
    { error, redirectRoute, user, isAuthenticated },
    { createSession, preventNextRedirect }
  ] = useAuth();

  React.useEffect(() => {
    const cs = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const loginType = window.localStorage.getItem("LOGIN_TYPE") || "MS-Email";
      window.localStorage.setItem("LOGIN_TYPE", loginType);
      await createSession(code, state);
    };

    if (!hasLoaded) {
      cs();
      setHasLoaded(true);
    }
  }, [createSession, hasLoaded]);

  // Show error screen if there's an error
  if (error) {
    if (error === "User Not Found") {
      return (
        <Container>
          <Content>
            <h2>Access Denied</h2>
            <p>
              You don't have permission to access this application. To request
              access, contact us at{" "}
              <a href={`mailto:${IMPLEMENTATION_EMAIL}`}>
                {IMPLEMENTATION_EMAIL}
              </a>
              .
            </p>
          </Content>
        </Container>
      );
    } else {
      return <ErrorMessage message={error} />;
    }
  }

  // Redirect if we have both a user and a redirect route
  if (redirectRoute && (user || isAuthenticated)) {
    preventNextRedirect();
    return <Redirect to={redirectRoute} />;
  }

  // Show loader while session is being created or while waiting for error/redirect
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.spinner}></div>
      <div className={styles.loadingText}>
        Authenticating your session, please wait...
      </div>
    </div>
  );
};

export default CreateSession;